export const TOGGLE_SIDEBAR = 'sidebar/TOGGLE_SIDEBAR';
export const SET_SKU_LINK_PREFIX = 'sidebar/SET_SKU_LINK_PREFIX';

export const CATEGORY_MENU = 'sidebar/CATEGORY_MENU';
